import { DeclarantId } from "../models/Declarant";

const SINGLE_DECLARANT_ACTION = (id: unknown): string => {
  return `/declarants/${id}`;
};

const DECLARANT_DEPARTMENT_DATA_ACTION = (id: unknown): string => {
  return `/declarants/${id}/department-data`;
};

export const API_UPDATE_CUSTOM_GROUP_ATTRIBUTES = (id: unknown): string => {
  return `/group-declarants/${id}/attributes`;
};

export const API_URL = process.env.REACT_APP_API_URL;

export const API_LOGIN_URL = "/login";
export const API_LOGOUT_URL = "/logout";
export const API_GET_USER_URL = "/user/me";

export const API_CHANGE_PASSWORD_URL = "/account/change-password";

export const API_GET_DECLARANTS_URL = "/declarants";
export const API_GET_SIGMA_URL = "/declarants/sigma";
export const API_GET_DECLARANTS_BY_USERS_URL = "/declarants/users";
export const API_GET_DELETED_DECLARANTS = "/declarants/deleted";
export const API_GROUP_DECLARANTS = "/declarants/group-by";
export const API_GET_DECLARANT_INVOICE_TYPES = "/declarants/invoice/types";
export const API_DECLARANT_TWS_SYNC = "/declarants/tws-sync";
export const API_DECLARANT_TWS_SYNC_BY_ID = (id: DeclarantId): string =>
  `/declarants/${id.toString()}/tws-resync`;

export const API_UPDATE_GROUP_DECLARANTS = (id: unknown): string =>
  `/group-declarants/${id}`;

export const API_GET_DECLARANTS_GROUPED_BY_CLIENTS = "/declarants/by-clients";
export const API_CREATE_DECLARANTS = "/declarants";
export const API_DECLARANTS_BY_USER_DEPARTMENT_URL = "/declarants/departments";
export const API_DECLARANTS_BY_USER_DEPARTMENT_GROUPED_URL =
  "/declarants/departments-grouped-by-clients";
export const API_UPDATE_DECLARANTS_URL = SINGLE_DECLARANT_ACTION;
export const API_DELETE_DECLARANT_URL = SINGLE_DECLARANT_ACTION;
export const API_ASSIGN_CLIENT_TO_DECLARANTS = "/declarants/assign-client";
export const API_UPDATE_DECLARANTS_DEPARTMENT_DATA = DECLARANT_DEPARTMENT_DATA_ACTION;

export const SEND_RESET_PASSWORD_REQUEST = "/password/reset/email";
export const RESET_PASSWORD_URL = "/password/reset";

export const API_IMPORT_DECLARANTS = "/declarants/import";

export const API_SAVE_USER_SETTING = "/user/settings";

export const API_GET_CLIENTS = "/clients";
export const API_GET_CLIENTS_WITH_NO_CLIENTS =
  "/clients/clients-including-no-client";
export const API_GET_CLIENTS_WITH_RATES = "/clients/with-rates";
export const API_GET_CLIENTS_FEE = "/clients/calculate-fee";

export const API_GET_CREATORS = "/declarants/creators";

export const API_GET_DEPARTMENTS = "/departments";

export const API_DOWNLOAD_XML = "/declarants/download";

export const API_CLEAR_DELETED_DECLARANTS_TABLE = "/declarants/deleted/all";

const DELETED_ACTION = (id: unknown): string => `/declarants/deleted/${id}`;

export const API_RESTORE_DECLARANT = DELETED_ACTION;

export const API_FORCE_DELETE_DECLARANT = DELETED_ACTION;

export const GROUP_DECLARANTS_BY_CLIENT = (clientId: unknown): string =>
  `/clients/${clientId}/group-declarants`;

export const LOAD_DEPARTMENT_DATA_SUMMARY = "/declarants/departments/summary";

export const DOWNLOAD_EXCEL_FILE = "/export-csv/department-data-csv-export";
export const DOWNLOAD_DECLARANT_TABLE_DATA_AS_EXCEL_FILE =
  "/export-csv/declarant-csv-export";
export const DOWNLOAD_LOGISTIC_TABLE_DATA_AS_EXCEL_FILE =
  "/export-csv/logistic-csv-export";
export const API_DOWNLOAD_CUSTOM_EXCEL_FILE_URL =
  "/export-csv/department-data-csv-custom-export";

export const API_CASHBOX_OPERATE = "/cashbox/operate";
export const API_LAST_ENCASHMENT_ACTION = (departmentId: unknown): string =>
  `/cashbox/${departmentId}/last-encashment`;

export const LOAD_CASHBOX_DATA_BY_DECLARANT = (declarantId: unknown): string =>
  `/cashbox/${declarantId}`;

export const GET_LATEST_DEPARTMENT_DATES = "/cashbox/departments";

const getAndUpdateCmrPath = (id: unknown): string => `/cmrs/${id}`;

export const API_CREATE_CMR = "/cmrs";
export const API_UPDATE_CMR = getAndUpdateCmrPath;
export const API_GET_CMR = getAndUpdateCmrPath;

export const API_GET_COUNTRIES = "/countries";
export const API_GET_SERVICES = "/services";

export const CMR_LIST = "/cmrs";

export const DELETE_CMR = (id: number): string => `/cmrs/${id}`;

export const DOWNLOAD_CMRS_PDF = (id: number): string => `/cmrs/${id}/download`;

export const ATTACH_DECLARANT_TO_CUSTOM_GROUP = (
  customGroupKey: unknown
): string => `/group-declarants/${customGroupKey}/attach`;

export const GET_CMR_NUMBER = "/cmrs/number";

export const COPY_TO_NEW_CMR = (id: unknown): string => `/cmrs/${id}/copy`;

export const API_AUTOCOMPLETE_CMR = "/cmrs/autocomplete";

//Logistic
export const API_GET_LOGISTIC_LIST = "/logistics";
export const API_SAVE_LOGISTIC_ENTITY = "/logistics";
export const API_UPDATE_LOGISTIC_ENTITY = (id: unknown) => `/logistics/${id}`;
export const API_DELETE_LOGISTIC_ENTITY = (id: unknown) => `/logistics/${id}`;
export const GET_SEARCH_FIELD_VALUES = (field: string) =>
  `/logistics/search/${field}`;
export const API_SAVE_LOGISTIC_DOCUMENTS = "/logistics/upload";
export const API_DOWNLOAD_LOGISTIC_DOCUMENT = "/logistics/download";
export const API_DELETE_LOGISTIC_DOCUMENT = (id: unknown) =>
  `/logistics/remove/${id}`;

//Contracts
export const API_DELETE_CONTRACTS_ENTITY = (id: unknown) => `/contracts/${id}`;
export const API_SAVE_CONTRACTS_ENTITY = "/contracts";
export const API_SAVE_CONTRACTS_DOCUMENTS = "/contracts/upload";
export const API_UPDATE_CONTRACTS_ENTITY = (id: unknown) => `/contracts/${id}`;
export const API_DOWNLOAD_CONTRACTS_DOCUMENT = "/contracts/download";
export const API_DELETE_CONTRACTS_DOCUMENT = (id: unknown) =>
  `/contracts/remove/${id}`;
export const API_GET_CONTRACTS_LIST = "/contracts";
export const GET_CONTRACTS_SEARCH_FIELD_VALUES = (field: string) =>
  `/contracts/search/${field}`;
export const DOWNLOAD_CONTRACTS_TABLE_DATA_AS_EXCEL_FILE =
  "/export-csv/contracts-csv-export";
export const STATUS_OPTIONS = "/contracts/status";

export const API_DECLARANTS_INVOICE = "/declarants/invoice";
export const API_DECLARANTS_REGISTER_OF_ACCOUNTS =
  "/export-csv/register-of-accounts";

// Fleet Expenses
export const API_FLEET_EXPENSE = "/fleet/expenses";
export const API_GET_FLEET_EXPENSES_TRANSPORTS = "/fleet/internal-tcs";
export const API_GET_FLEET_EXPENSES_SPENDING_TYPES = "/fleet/spending-types";
export const API_GET_FLEET_DRIVERS = "/fleet/drivers";
export const API_GET_FLEET_DRIVER_CARD_ASSIGNMENTS = (
  driverId: number
): string =>
  `/fleet/drivers/${driverId}/card-assignments`;
